import Vue from 'vue'
import VueI18n from 'vue-i18n'

// i18n
import enLocale from 'element-ui/lib/locale/lang/en'
import cnLocale from 'element-ui/lib/locale/lang/zh-CN'
import twLocale from 'element-ui/lib/locale/lang/zh-TW'
import en from './lang/en.js'                    // 存放英文翻譯
import cn from './lang/zh_CN.js'                 // 存放繁體中文翻譯
import tw from './lang/zh_TW.js'                 // 存放繁體中文翻譯

Vue.use(VueI18n)

const messages = {
    en: {
      ...en,
      ...enLocale
    },
    cn: {
      ...cn,
      ...cnLocale
    },
    tw: {
      ...tw,
      ...twLocale
    }
}

const i18n = new VueI18n({
    /** 默认值 */
    locale : 'tw',
    messages
})

export default i18n


// WEBPACK FOOTER //
// ./src/i18n/lang.js